import React, { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface RoleProtectedRouteProps {
  children: ReactElement;
  allowedRoles: string[];
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ children, allowedRoles }) => {
  const location = useLocation();
  const token = typeof window !== 'undefined' ? localStorage.getItem('access_token') : null;
  const userRole = typeof window !== 'undefined' ? localStorage.getItem('userRole') : null;

  // Check if user is authenticated
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Check if user has required role
  if (!userRole || !allowedRoles.includes(userRole)) {
    // Redirect based on user role
    if (userRole === "ADMIN") {
      return <Navigate to="/admin" replace />;
    } else if (userRole === "DOCTOR") {
      return <Navigate to="/dashboard" replace />;
    } else {
      // Unknown role, redirect to login
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default RoleProtectedRoute;